// extracted by mini-css-extract-plugin
export default {"AddPart":"styles_AddPart__WGbM4","AddPart-form_container":"styles_AddPart-form_container__dqopp","AddPart-btnContainer":"styles_AddPart-btnContainer__q9FH8"};